import { render, staticRenderFns } from "./GroupCriticalSummary.vue?vue&type=template&id=5e244424&scoped=true&"
import script from "./GroupCriticalSummary.vue?vue&type=script&lang=js&"
export * from "./GroupCriticalSummary.vue?vue&type=script&lang=js&"
import style0 from "./GroupCriticalSummary.vue?vue&type=style&index=0&id=5e244424&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e244424",
  null
  
)

export default component.exports